import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
export function TestimonialsInitial() {
  const testimonials = [{
    quote: 'Llegué al Día 21 y mi perro se quedó solo sin ladrar por primera vez en dos años. Nunca pensé que podía. Ahora salgo al trabajo sin ese nudo en el pecho.',
    name: 'Romina G.',
    location: 'Buenos Aires',
    initials: 'RG'
  }, {
    quote: 'El consorcio me había mandado tres notas. Apliqué el protocolo y en la segunda semana el vecino me paró para preguntarme qué había hecho.',
    name: 'Diego M.',
    location: 'Córdoba',
    initials: 'DM'
  }, {
    quote: 'Antes llegaba a casa con miedo de lo que iba a encontrar. Ahora entro tranquila. Cambió todo.',
    name: 'Laura V.',
    location: 'Rosario',
    initials: 'LV'
  }];
  return <section className="py-12 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto" data-id="element-287">
      <div className="grid md:grid-cols-3 gap-6" data-id="element-288">
        {testimonials.map((t, index) => <motion.div key={index} initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: index * 0.1
      }} className="bg-navy-800/50 border border-navy-700 p-6 rounded-2xl backdrop-blur-sm flex flex-col h-full" data-id="element-289">
            <div className="flex items-center gap-3 mb-4" data-id="element-290">
              <div className="w-10 h-10 rounded-full bg-navy-700 flex items-center justify-center text-gold-400 font-bold text-sm" data-id="element-291">
                {t.initials}
              </div>
              <div className="flex gap-1" data-id="element-292">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-gold-400 text-gold-400" data-id="element-293" />)}
              </div>
            </div>
            <p className="text-base text-blue-50 italic mb-4 flex-grow" data-id="element-294">
              "{t.quote}"
            </p>
            <p className="text-gold-400 font-medium text-sm" data-id="element-295">
              — {t.name} | {t.location}
            </p>
          </motion.div>)}
      </div>
    </section>;
}